import "./PulseFABButton.css";
import { Link, useLocation } from "react-router-dom";
// import grandLogo from '../../assets/grand/GRAN-D-elementos-02.svg'

function PulseFabButton({ returnIfPathnameIs, imageSrc, text, backgroundColor = 'transparent', redirectTo }) {
    const { pathname } = useLocation()

    const _returnIfPathnameIs = Array.isArray(returnIfPathnameIs) ? returnIfPathnameIs : [returnIfPathnameIs]

    if (_returnIfPathnameIs.length > 0 && _returnIfPathnameIs.includes(pathname)) return null
    return (
        <div className="pulseFabButton-container"
            style={{
                backgroundColor
            }}>
            <Link
                className="pulseFabButton-button"
                to={redirectTo}
                target="_blank"

            >
                {imageSrc && <img src={imageSrc} alt='GranD' />}
                {text && <p className="pulseFabButton--text">{text}</p>}
            </Link>
        </div>
    );
}

export default PulseFabButton;